import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment} from '@api'
import {IconName} from '@blueprintjs/core'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {ReactElement} from 'react'
import * as css from './AssortmentClearCardSettingsGlobal.css'

/// region Store

export class AssortmentClearCardSettingsGlobalStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)

    this.assortmentTooltips = new AssortmentTooltipStrings(this)
  }

  @observable.ref assortmentTooltips : AssortmentTooltipStrings

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get settings() {
    const {catalog: {assortments: {settings}}} = this
    return settings
  }

  get hideAllHeaders() { return this.settings.hideAllHeaders === true}
  set hideAllHeaders(v) { this.settings.hideAllHeaders = v === true}

  get hideAll2ndLevel() { return this.settings.hideAll2ndLevel === true}
  set hideAll2ndLevel(v) { this.settings.hideAll2ndLevel = v === true}

  get hideAllFooters() { return this.settings.hideAllFooters === true}
  set hideAllFooters(v) { this.settings.hideAllFooters = v === true}

  @computed get hiddenHeaders() {
    const {settings: {byCard}} = this
    return _.values(byCard).filter(v => v.hideHeader)
  }

  @action onClickHeadersButton = () => {
    const {hideAllHeaders, hiddenHeaders} = this
    if (!hideAllHeaders && !_.isEmpty(hiddenHeaders)) {
      hiddenHeaders.forEach(v => v.hideHeader = false)
    }
    else {
      this.hideAllHeaders = !hideAllHeaders
    }
  }

  @computed get zoomedCards() {
    const {settings: {byCard}} = this
    return _.values(byCard).filter(v => v.zoomed)
  }

  @action clearZoomedCards = () => {
    this.zoomedCards.forEach(v => v.zoomed = false)
  }

  @computed get hidden2ndLevel() {
    const {settings: {byCard}} = this
    return _.values(byCard).filter(v => v.hideSecondLevel)
  }

  @action onClick2ndLevel = () => {
    const {hideAll2ndLevel, hidden2ndLevel} = this
    if (!hideAll2ndLevel && !_.isEmpty(hidden2ndLevel)) {
      hidden2ndLevel.forEach(v => v.hideSecondLevel = false)
    } else {
      this.hideAll2ndLevel = !hideAll2ndLevel
    }

    this.hidden2ndLevel.forEach(v => v.hideSecondLevel = false)
  }

  @computed get hiddenFooters() {
    const {settings: {byCard}} = this
    return _.values(byCard).filter(v => v.hideFooter)
  }

  @action onClickFootersButton = () => {
    const {hideAllFooters, hiddenFooters} = this
    if (!hideAllFooters && !_.isEmpty(hiddenFooters)) {
      hiddenFooters.forEach(v => v.hideFooter = false)
    } else {
      this.hideAllFooters = !hideAllFooters
    }
  }
}

export const AssortmentClearCardSettingsGlobalStoreContext = React.createContext<AssortmentClearCardSettingsGlobalStore>(null)
export const useAssortmentClearCardSettingsGlobalStore = () => React.useContext(AssortmentClearCardSettingsGlobalStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const AssortmentClearCardSettingsGlobal = observer<MyProps>(function AssortmentClearCardSettingsGlobal({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new AssortmentClearCardSettingsGlobalStore(stores, obsProps)),
    {catalog: {settings: {assortment: settings, assortment: {fluidCards}}}, hidden2ndLevel, onClickFootersButton, hideAllFooters, hiddenFooters, hideAll2ndLevel, hiddenHeaders, hideAllHeaders, onClick2ndLevel, clearZoomedCards, onClickHeadersButton, zoomedCards, assortmentTooltips: tooltip} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <div className={css.root}>
      <PrimaryIconButton icon={assortmentIcons.headers} active={!hideAllHeaders && _.isEmpty(hiddenHeaders)} tooltip={tooltip.toggleHeaders} tooltipPosition='top' tooltipStyle='mui' onClick={onClickHeadersButton} />
      {/*<PrimaryIconButton icon={assortmentIcons.zoom} tooltip={tooltip.zoom} tooltipPosition='top' tooltipStyle='mui' onClick={clearZoomedCards}/>*/}
      <PrimaryIconButton icon={assortmentIcons.secondLevel} active={!hideAll2ndLevel && _.isEmpty(hidden2ndLevel)} tooltip={tooltip.toggle2ndLevel} tooltipPosition='top' tooltipStyle='mui' onClick={onClick2ndLevel}/>
      <PrimaryIconButton icon={assortmentIcons.footer} active={!hideAllFooters && _.isEmpty(hiddenFooters)}  tooltip={tooltip.footer} tooltipPosition='top' tooltipStyle='mui' onClick={onClickFootersButton}/>
      <PrimaryIconButton icon={'arrows-horizontal'} active={fluidCards} tooltip={'Responsive Cards'} tooltipPosition='top' tooltipStyle='mui' onClick={() => settings.fluidCards = fluidCards != true}/>
    </div>
  )
})

/// endregion

export class AssortmentTooltipStrings {
  constructor(public store: AssortmentClearCardSettingsGlobalStore) {}

  @computed get toggleHeaders() {
    const {store: {hiddenHeaders, hideAllHeaders}} = this
    return `Card Headers`  //${(hideAllHeaders || hiddenHeaders.length > 0) ? 'Show' : 'Hide'} Headers`
  }

  @computed get zoom() {
    return 'Zoom'
  }

  @computed get toggle2ndLevel() {
    const {store: {hidden2ndLevel}} = this
    return `2nd Level Cards `
  }

  @computed get footer() {
    return 'Card Footers'
  }
}

export const assortmentIcons : Record<'zoom' | 'secondLevel' | 'headers' | 'footer', ReactElement<any> | IconName>= {
  zoom: 'zoom-in',
  secondLevel: 'id-number',
  headers: 'header',
  footer: 'widget-footer'
}



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentClearCardSettingsGlobal.tsx